import React, { useState } from "react";
import IntroVideo from '../videos/Axis_background.mp4';
import VideoComponent from './VideoComponent.js';
import Axis_Logo from '../images/Axis_image6.png';
import PageSEO from "../components/seo/PageSEO";
import { buyApp } from "../services/api";
import { useScrollBehavior } from './useScrollBehavior.js';
import ComingSoonModal from '../components/ComingSoonModal';
import "../styles/home.css";

export default function AppDownload() {
  useScrollBehavior();

  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  /*async function handleBuy() {
    setError("");
    setLoading(true);
    try {
      const data = await buyApp();
      if (data.checkoutUrl) window.location.href = data.checkoutUrl;
      if (data.downloadUrl) window.location.href = data.downloadUrl;
    } catch (e) {
      setError(e.message || "Purchase failed");
    } finally {
      setLoading(false);
    }
  }*/
 function handleBuy() {
  setModalOpen(true);
}

  return (
    <main className="home">
      <PageSEO
        title="Get the App | The Axis"
        description="The Axis platform — posts, DMs, community updates, and more. Download after purchase."
        path="/app"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "The Axis App",
          "url": (process.env.REACT_APP_SITE_URL || "") + "/app"
        }}
      />

      <div className="home__bg" aria-hidden="true">
        <VideoComponent videoSrc={IntroVideo} />
      </div>

      <section className="home__content">

        {/* ── HERO ── */}
        <div className="module" style={{
          minHeight: '100vh',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div className="home__logo">
            <img src={Axis_Logo} alt="Axis logo" className="axis_logo" />
          </div>
          <span className="about__eyebrow">The Axis</span>
          <h1 className="home__title">The Platform</h1>
          <p className="home__subtitle">Connect • Organize • Act</p>
          <p className="home__copy">
            The Axis app is the operational layer of the organization — where members
            communicate, share ideas, coordinate action, and stay connected to the
            broader mission. Built from the ground up with the Sacred Three embedded
            in its architecture.
          </p>
          <p className="home__copy" style={{ marginTop: '0.75rem' }}>
            Download link delivered immediately after purchase.
          </p>

          <div className="home__cta" style={{ marginTop: '1.5rem' }}>
            <button
              className="btn btn--primary"
              onClick={handleBuy}
              disabled={loading}
            >
              {loading ? "Processing…" : "Buy + Download"}
            </button>
            <a className="btn btn--ghost" href="/contact">
              Contact Us
            </a>
          </div>

          {error && (
            <p style={{ color: '#ff9aa9', marginTop: '1rem', fontSize: '0.9rem' }}>
              {error}
            </p>
          )}
        </div>

        {/* ── FEATURES ── */}
        <div className="module" style={{
          minHeight: 'auto',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: '4rem',
          paddingBottom: '4rem'
        }}>
          <h2 className="module__heading">What's Inside</h2>
          <div className="features__grid" style={{ marginBottom: 0 }}>

            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 6h24v20H4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                  <path d="M8 11h16M8 16h10M8 21h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Posts & Discourse</h4>
              <p className="feature__body">
                Share ideas and engage in principled discussion within a
                community guided by the Axis values.
              </p>
            </div>

            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26 6H6a2 2 0 00-2 2v12a2 2 0 002 2h14l6 4V8a2 2 0 00-2-2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Direct Messages</h4>
              <p className="feature__body">
                Private communication built on trust and the mutual
                obligations of the Social Contract.
              </p>
            </div>

            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M16 10v6l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Community Updates</h4>
              <p className="feature__body">
                Curated news and updates from communities committed
                to the Axis principles.
              </p>
            </div>

            <div className="feature">
              <div className="feature__icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 4l3.09 6.26L26 11.27l-5 4.87 1.18 6.88L16 19.77l-6.18 3.25L11 16.14 6 11.27l6.91-1.01L16 4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature__title">Admin News</h4>
              <p className="feature__body">
                Transparent governance updates from platform administrators —
                accountability built in, not bolted on.
              </p>
            </div>

          </div>

          <div className="home__cta" style={{ marginTop: '2.5rem' }}>
            <button
              className="btn btn--primary"
              onClick={handleBuy}
              disabled={loading}
            >
              {loading ? "Processing…" : "Buy + Download"}
            </button>
          </div>

          {error && (
            <p style={{ color: '#ff9aa9', marginTop: '1rem', fontSize: '0.9rem' }}>
              {error}
            </p>
          )}
        </div>

      </section>
      <ComingSoonModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          title="Platform Launching Soon"
          message="The Axis platform is currently in development. We are building something worth waiting for. Check back soon or contact us to stay in the loop."
        />
    </main>
  );
}



/*import React, { useState } from "react";
import PageSEO from "../components/seo/PageSEO";
import "../styles/product.css";
import { buyApp } from "../services/api";
import { useScrollBehavior } from './useScrollBehavior.js';

export default function AppDownload() {

  useScrollBehavior();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleBuy() {
    setError("");
    setLoading(true);
    try {
      const data = await buyApp();
      // Expected response: { checkoutUrl } or { downloadUrl }
      if (data.checkoutUrl) window.location.href = data.checkoutUrl;
      if (data.downloadUrl) window.location.href = data.downloadUrl;
    } catch (e) {
      setError(e.message || "Purchase failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="page">
      <PageSEO
        title="Get the App | Your App Name"
        description="Download and buy the app."
        path="/app"
      />

      <header className="pageHeader">
        <h1>Get the App</h1>
        <p>Download links are delivered after purchase.</p>
      </header>

      <section className="section">
        <div className="productCard">
          <h2>Mobile App</h2>
          <p>
            Posts, DMs, reactions, admin news, and more.
          </p>
          <div className="ctaRow">
            <button className="btn btnPrimary" onClick={handleBuy} disabled={loading}>
              {loading ? "Processing…" : "Buy + Download"}
            </button>
            <a className="btn btnGhost" href="/contact">
              Contact Sales
            </a>
          </div>
          {error ? <div className="formError">{error}</div> : null}
          <div className="finePrint">
            Lambda endpoints are stubbed. Wire to Stripe + S3 presigned URLs when ready.
          </div>
        </div>
      </section>
    </main>
  );
}*/
